import { ReactElement, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";
import deleteReport from "@services/Clients/WhaleShark/report/deleteItem";
import useListColumns from "@hooks/Clients/WhaleShark/report/useListColumns";
import useDeleteItem from "@hooks/Shared/useDeleteItem";
import ModalConfirmation from "@components/ModalConfirmation";
import CreateBtn from "@components/CreateButton";
import Loader from "@components/Loader";
import Title from "@components/Title";
import Table from "@components/Table";
import { EUiStates } from "@constants/enum";
import useListItems from "@hooks/Shared/useListItems";
import getReports from "@services/Clients/WhaleShark/report/getItems";
import listMapper from "@mappers/Clients/WhaleShark/report/ListReport.mapper";

const ListItems = (): ReactElement => {
  const { t } = useTranslation(["core", "whaleshark"]);
  const [isDeletingItem, setIsDeletingItem] = useState(false);
  const { isLoading, basicData, tableItems } = useListItems(
    isDeletingItem,
    getReports,
    listMapper
  );
  const { isModalOpen, isDeleting, handleDelete, handleIsModalOpen } =
    useDeleteItem(basicData);
  const COLUMNS = useListColumns();

  useEffect(() => {
    setIsDeletingItem(isDeleting);
  }, [isDeleting]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container>
      <ModalConfirmation
        icon="trash"
        title={`Whale Shark | ${t("whaleshark:common.report")} | ${t(
          "core:common.delete_confirm"
        )}`}
        body={`${t("core:notifications.delete_message")} "${
          basicData?.description
        }" ?`}
        handleConfirm={() => {
          handleDelete(deleteReport);
        }}
        handleModalStatus={handleIsModalOpen}
        modalStatus={isModalOpen}
        modalType={EUiStates.DANGER}
      />

      <Title />
      <CreateBtn />
      <Table columns={COLUMNS} items={tableItems} />
    </Container>
  );
};

export default ListItems;
